export default __webpack_public_path__ + "static/media/upload-white.20ab4120.svg";